<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
                @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents.Document' })"
                show-expand
                @item-expanded="itemExpanded"
                :expanded.sync="expanded"
                >

                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>
                 
                <template v-slot:[`item.data-table-expand`]="{ isExpanded, expand }">
                    <v-btn 
                        icon
                        x-small
                        plain
                        class="expand-cust-btn"
                        @click="expand(true)" 
                        v-if="!isExpanded"
                    >
                        <v-icon>
                            fas fa-caret-right
                        </v-icon>
                    </v-btn>
                    <v-btn 
                        icon
                        x-small
                        plain
                        class="expand-cust-btn"
                        @click="expand(false)" 
                        v-else
                    >
                        <v-icon>
                            fas fa-caret-down
                        </v-icon>
                    </v-btn>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                        <div class="table-expanded-wrapper">

                            <template v-if="item._info">
                                <v-treeview 
                                    dense
                                    :items="item._info"
                                    class="cust-treeview-in-list"
                                    :open.sync="open[item.id]"
                                    >
                                    <template v-slot:label="{ item }">

                                        <template v-if="item.text=='Link'">
                                                
                                            <div class="d-flex align-center">
                                                <span class="linked-docs-title">{{ $t(GetLinkedTypes[item.type]) }}</span>
                                                <div class="onlyReadData more-per-lab-wrap">
                                                    {{ item.Values }}
                                                    <v-doc-chip
                                                        v-for="(doc, index) in item.values"
                                                        :key="item.type+index"
                                                        :id="doc.Values[6]"
                                                        :link-id="doc.Values[0]"
                                                        :name="$t(GetDocumentTypes[doc.Values[9]]) + ' № ' + doc.Values[2] + ` ${$t('от_время')} ` + doc.Values[3] + (doc.Values[5] ? ' (' + doc.Values[5] + ')' : '')" 
                                                        iconColor="#7289DA"
                                                        :is-linked-document="true"
                                                        :source-document-id="item.sourceDocumentId"
                                                    />
                                                </div>
                                            </div>

                                        </template>
                                        <template v-else-if="item.text=='Notify'">
                                            <div class="d-flex ctil-row-wrap">
                                                <div class="flex-grow-1">
                                                    <div class="elipsis-text-wrap">
                                                        <span>
                                                            {{ $t("Уведомление") }}
                                                        </span>
                                                        <span>
                                                            {{ item.Values[0] }}
                                                        </span>
                                                        <span>
                                                            <v-employee-chip :id="item.Values[3]" :name="item.Values[2]" /> 
                                                        </span>
                                                        <div class="etw-text-container" v-tooltip.top-center="item.Values[1]">
                                                            <span class="etw-text">
                                                                {{ item.Values[1] }}
                                                            </span>
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>                                           
                                        </template>
                                        <template v-else-if="item.text=='0'">
                                            <div class="d-flex ctil-row-wrap">
                                                <div class="d-flex align-center flex-grow-1">
                                                    <div class="elipsis-text-wrap">
                                                        <span v-if="item.Values[14] == 'True'">
                                                            {{ $t("Резолюция") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ $t("Внешняя") }}
                                                        </span>
                                                        
                                                        <span>
                                                            {{ item.Values[8] }}
                                                        </span>

                                                        <v-employee-chip v-if="item.Values[14] == 'True'" :id="item.Values[7]" :name="item.Values[1]" :is-employee="true" />
                                                        <v-enterprise-chip v-else :name="item.Values[1]" />

                                                        <i v-if="item.Values[13] === 'True'" class="fas fa-glasses signer-control-i" v-tooltip.top-center="isSignerControlTooltip"></i>

                                                        <div class="etw-text-container" v-tooltip.top-center="item.Values[2]">
                                                            <span class="etw-text">
                                                                {{ item.Values[2] }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-center flex-grow-0" style="width:110px;">
                                                    <span v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss')">
                                                        {{ dateFormat(item.Values[4], 'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss') }}
                                                    </span>
                                                </div>
                                                <div class="d-flex align-center flex-grow-0 status-dropdown-col" style="width:150px;">
                                                    <div class="onlyReadData more-per-lab-wrap"> 
                                                        <StatusChip
                                                            v-if="item.Values[14] == 'False' && item.hasExecutions"
                                                            :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1', 10))]"
                                                        />

                                                        <template v-else-if="item.Values[14] == 'True'">
                                                            <StatusChip
                                                                v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss') && getDaysDiff(item.Values[4]) > -1 && item.Values[5] == '5'"
                                                                :status="avaibleStatuses[$helpers.getTaskStatus(1)]"
                                                            />
                                                            <StatusChip
                                                                v-else
                                                                :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1'), 10)]"
                                                            />

                                                        </template>
                                                        
                                                        <StatusChip v-if="item.Values[19] || null" :status="avaibleStatuses[$options.rssStatusKeys[parseInt(item.Values[19] || '0')]]" />                    
                                                    </div>
                                                </div>
                                            </div>                                              
                                        </template>
                                        <template v-else-if="item.text=='1'">
                                            <div class="d-flex ctil-row-wrap">
                                                <div class="d-flex align-center flex-grow-1">
                                                    <div class="elipsis-text-wrap">
                                                        <span>{{$t("Исполнитель")}}</span>
                                                        <v-enterprise-chip
                                                            v-if="item.Values[9] === '00000000-0000-0000-0000-000000000000'"
                                                            :name="item.Values[1]"
                                                            :iconColor="executerStatusColor(item.Values[8])"
                                                            :main="item.Values[6] == 'True'"
                                                        />
                                                        <v-workplace-chip
                                                            v-else
                                                            :id="item.Values[9]"
                                                            :name="item.Values[0]"
                                                            :iconColor="executerStatusColor(item.Values[8])"
                                                            :main="item.Values[6] == 'True'"
                                                            :is-employee="true"
                                                        />

                                                        <div class="etw-text-container" v-tooltip.top-center="item.Values[5]">
                                                            <span class="etw-text">
                                                                {{ item.Values[5] }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-center flex-grow-0" style="width:110px;">
                                                    <span v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss')">
                                                        {{ dateFormat(item.Values[4], 'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss') }}
                                                    </span>
                                                </div>
                                                <div class="d-flex align-center flex-grow-0 status-dropdown-col" style="width:150px;">
                                                    <StatusChip :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[2] || '-1', 10))]" />
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else-if="item.text=='2'">
                                            <div class="d-flex ctil-row-wrap">
                                                <div class="d-flex align-center flex-grow-1">
                                                    <div class="elipsis-text-wrap">
                                                        <span>
                                                            {{ $t("Пункт") }} № {{ item.Values[15] }}
                                                        </span>
                                                        
                                                        <span>
                                                            {{ item.Values[8] }}
                                                        </span>

                                                        <v-employee-chip v-if="item.Values[14] == 'True'" :id="item.Values[7]" :name="item.Values[1]" :is-employee="true" />
                                                        <v-enterprise-chip v-else :name="item.Values[1]" />

                                                        <i v-if="item.Values[13] === 'True'" class="fas fa-glasses signer-control-i" v-tooltip.top-center="isSignerControlTooltip"></i>

                                                        <div class="etw-text-container" v-tooltip.top-center="item.Values[2]">
                                                            <span class="etw-text">
                                                                {{ item.Values[2] }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-center flex-grow-0" style="width:110px;">
                                                    <span v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss')">
                                                        {{ dateFormat(item.Values[4], 'DD.MM.YYYY', 'DD.MM.YYYY HH:mm:ss') }}
                                                    </span>
                                                </div>
                                                <div class="d-flex align-center flex-grow-0 status-dropdown-col" style="width:150px;">
                                                    <div class="onlyReadData more-per-lab-wrap"> 
                                                        <StatusChip
                                                            v-if="item.Values[14] == 'False' && item.hasExecutions"
                                                            :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1', 10))]"
                                                        />

                                                        <template v-else-if="item.Values[14] == 'True'">
                                                            <StatusChip
                                                                v-if="dateFormat(item.Values[4], 'YYYY', 'DD.MM.YYYY HH:mm:ss') && getDaysDiff(item.Values[4]) > -1 && item.Values[5] == '5'"
                                                                :status="avaibleStatuses[$helpers.getTaskStatus(1)]"
                                                            />
                                                            <StatusChip
                                                                v-else
                                                                :status="avaibleStatuses[$helpers.getTaskStatus(parseInt(item.Values[5] || '-1'), 10)]"
                                                            />

                                                        </template>
                                                        
                                                        <StatusChip v-if="item.Values[19] || null" :status="avaibleStatuses[$options.rssStatusKeys[parseInt(item.Values[19] || '0')]]" />                    
                                                    </div>
                                                </div>
                                            </div>        
                                        </template>                                      
                                        <template v-else>
                                            {{ getLabel(item) }}
                                        </template>
                                        
                                    </template>
                                </v-treeview>
                            </template>
                            <v-progress-linear v-else
                                color="#a94442"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>

                        </div>
                    </td>
                </template>

                <template v-slot:[`item.regdate`]="{ item }">
                    <div>{{dateFormat(item.regdate, 'DD.MM.YYYY')}}</div>
                </template>

                <template v-slot:[`item.outdate`]="{ item }">
                    <div>{{dateFormat(item.outdate, 'DD.MM.YYYY')}}</div>
                </template>

                <template v-slot:[`item.correspondent`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <v-enterprise-chip :name="item.correspondent" />
                    </div>
                </template>
                
                <template v-slot:[`item.theme`]="{ item }">
                    <div class="elipsis-text-wrap">                        
                        <v-doc-type-chip :type="item.doctypeof" :text="item.doctype"/>
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.theme">
                                {{item.theme}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.controldate`]="{ item }">
                    <div>{{dateFormat(item.controldate, 'DD.MM.YYYY')}}</div>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        </v-col>

    </v-row>
</template>

<script>
import Axios from 'axios';
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";
import adapter from "@/services/adapter";
import StatusChip from '@/components/global/chips/StatusChip';
import { mapGetters } from 'vuex';

export default {
    rssStatusKeys:["", "rssOnSign", "rssSignedByChief", "rssSended"],
    columnIndex:  {
        'regnumber': 2,
        'regdate': 4,
        'correspondent': 5,
        'theme': 6,
        'controldate': 7,
        'outnumber': 14,
        'outdate': 15
    },
    props: {
        status: {
            type: String,
            default: null
        },
        search: {
            type: String,
            default: ""
        }
    },
    components: {
        StatusChip
    },
    data () {
        return {
            loading: true,
            cancellationTokenSorce: null,
            total: 0,            
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
            expanded: [],
            open: {},
        }
    },
    computed: {
        ...mapGetters('documents/references', ['GetLinkedTypes', 'GetDocumentTypes']),
        headers() {
            return [
                { text: this.$t("Рег._№"), value: 'regnumber', width: '120px' },
                { text: this.$t("Рег._дата"), value: 'regdate', width: '110px' },
                { text: this.$t("Исх_№"), value: 'outnumber', width: '120px' },
                { text: this.$t("Дата_исходящего"), value: 'outdate', width: '140px' },
                { text: this.$t("Корреспондент"), value: 'correspondent', width: '10%' },
                { text: this.$t("Краткое_содержание"), value: 'theme'},
                { text: this.$t("Срок"), value: 'controldate', width: '110px' },
                { text: this.$t("Статус"), value: '', width: '130px', sortable: false, class: 'status-col'}
            ];
        },
        options: {
            get: function() {
                return this.$store.getters['archive/lists/documents/incomings/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('archive/lists/documents/incomings/SET_TABLE_OPTION', newValue);
            }
        },
        collection () {
            return this.$store.getters['archive/lists/documents/getCollection'];
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                ArchYear: this.status,
                extendedFilterData: this.$helpers.getOnlySelectedParams(this.extendedTableFilter)
            }
        },
        extendedTableFilter() {
            return this.$store.getters['archive/lists/documents/getExtendedFilter'];
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        },
        isSignerControlTooltip () {
            return this.$t("Личный_контроль");
        },
    },
    methods: {
        async itemExpanded(val) {

            if (!val.value)
                return;
            
            this.$set(val.item, '_info', null)

            let response = await httpAPI({
                url: `api/archive/get-document-children/${val.item.id}`,
                method: 'GET',
            });
            
            let data = response?.data?.Payload?.Data?.Object?.data;
            
            if (data) {
                let treeData = adapter.transformTreeData(null, data, val.item.id);
                this.$set(val.item, '_info', treeData)
            }          
        },
        getLabel(item){
            return item.Values.toString();
        },
        resetPage() {
            this.$store.commit('archive/lists/documents/incomings/SET_TABLE_OPTION_PAGE', 1);
        },
        async getData(isRefresh = false) {            
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
                
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;
            this.$emit("change_loaddata_status",this.loading);    

            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();
            
            let response = await httpAPI({
                url: `api/archive/list?collection=${this.collection}&filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.expanded = [];
            this.entities = response.data?.Payload?.data ?? [];
            this.total = response.data?.Payload?.total ?? 0;
            this.loading = false;
            this.$emit("change_loaddata_status",this.loading);    
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, ArchYear, extendedFilterData } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "regdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 4;

            return { 
                SearchStr,
                ArchYear,
                DocType: "Avrora.Objects.Modules.Docflow.DocflowObjects.IncomingDocument",
                IncomingDocumentType: "0",
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage,
                ...extendedFilterData
            };
        },
        dateFormat: sys.dateFormat,
        getDaysDiff(controlDate) {
            let diff = this.$moment(controlDate,'DD.MM.YYYY HH:mm:ss').diff(this.$moment(Date.now()), 'days');
            return diff;
        },
        executerStatusColor(item) {
            switch(item)
            {
                case 'success':
                    return "#43B581";
                case 'warning':
                    return "#FAA61A";
                case 'danger':
                    return "#F04747";
                default:
                    return null;
            }
        },
        async oneStatusColWidth() {
            var parent = document.getElementsByClassName('content-box')[0];
            var status_col_obj = parent.getElementsByClassName('status-col');
            var status_dropdown_col_obj = parent.getElementsByClassName('status-dropdown-col');
            var status_col_w = status_col_obj.length > 0 ? status_col_obj[0].clientWidth : 0;
            if(status_dropdown_col_obj.length > 0){
                for (var index = 0; index < status_dropdown_col_obj.length; index++) {
                    status_dropdown_col_obj[index].style.width = status_col_w + "px";
                }
            }
        }
    },
    mounted() {
        this.$nextTick(this.oneStatusColWidth);
        window.addEventListener('resize', this.oneStatusColWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.oneStatusColWidth);
    },
    watch: {
        filter: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        open: {
            handler() {
                this.$nextTick(this.oneStatusColWidth);
            },
            deep: true,
        }
    },
}
</script>
